import AdminOrganizationIndex from '@/pages/admin/organization/Index'
import AdminOrganizationAdd from '@/pages/admin/organization/Add'
import AdminOrganizationEdit from '@/pages/admin/organization/Edit'

export default [
  {
    path: '/admin/organization',
    name: 'AdminOrganizationIndex',
    component: AdminOrganizationIndex,
    meta: {
      roles: ['ROLE_ADMIN'],
      title: 'Список организаций'
    }
  },
  {
    path: '/admin/organization/add',
    name: 'AdminOrganizationAdd',
    component: AdminOrganizationAdd,
    meta: {
      roles: ['ROLE_ADMIN'],
      title: 'Добавление организации'
    }
  },
  {
    path: '/admin/organization/edit/:id',
    name: 'AdminOrganizationEdit',
    component: AdminOrganizationEdit,
    props: true,
    meta: {
      roles: ['ROLE_ADMIN'],
      title: 'Редактирование организации'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/admin/organization.js